import React from 'react';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/UI/Typography';
import PhotoUploader from 'Views/Onboarding/Components/PhotoUploader';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDBox, FDStack } from '@facet-wealth/design';

const styles = () => ({
  title: {
    fontSize: '32px',
    textAlign: 'center',
  },
});

function PersonalInformationLayout({
  classes,
}) {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  useScrollTopOnMount();

  if (!resource) return null;

  return (
    <FDBox>
      <PhotoUploader
        resource={resource}
      />
      <FDStack direction={'column'} spacing={5}>
        <Typography
          className={classes.title}
          variant={'h1'}
          color={'primary'}
          weight={'medium'}
        >
          {resource.attr('title')}
        </Typography>
        <FDBox>
          <MetaField attr={'firstName'} />
          <MetaField attr={'lastName'} />
          <MetaField attr={'dateOfBirth'} />
          <MetaField attr={'maritalStatus'} />
        </FDBox>
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDBox>
  );
}

PersonalInformationLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

PersonalInformationLayout.defaultProps = {
};

export default withStyles(styles)(PersonalInformationLayout);
